"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95025],{

/***/ 71955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vC": function() { return /* binding */ WebsocketRequest; },
  "XC": function() { return /* binding */ websocket_pb_WebsocketResponse; }
});

// UNUSED EXPORTS: WebsocketRequest_Request, WebsocketRequest_Request_Channel, WebsocketRequest_Request_Command

// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/proto3.js + 19 modules
var esm_proto3 = __webpack_require__(7722);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/google/protobuf/timestamp_pb.js
var timestamp_pb = __webpack_require__(27251);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/ping_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/ping.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message platform.websocket.wsevent.v1.PingRequest
 */
const PingRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "platform.websocket.wsevent.v1.PingRequest",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message platform.websocket.wsevent.v1.PingResponse
 */
const PingResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.PingResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/auth_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/auth.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message platform.websocket.wsevent.v1.AuthRequest
 */
const AuthRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "platform.websocket.wsevent.v1.AuthRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message platform.websocket.wsevent.v1.AuthResponse
 */
const AuthResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.AuthResponse",
  [],
);


// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/entity/v2/portfolio_pb.js + 3 modules
var portfolio_pb = __webpack_require__(80139);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/wsevent/v1/securities_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/wsevent/v1/securities.proto (package securities.trm.core.portfolio.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * WebsocketResponse defines messages when sending response to websocket client
 *
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse
 */
const WebsocketResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "action", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketResponse_Action) },
    { no: 2, name: "portfolio_summary", kind: "message", T: portfolio_pb/* PortfolioSummary */.XJ, oneof: "message" },
    { no: 3, name: "portfolio_detail", kind: "message", T: portfolio_pb/* PortfolioDetail */.$2, oneof: "message" },
    { no: 4, name: "portfolio_list", kind: "message", T: portfolio_pb/* PortfolioList */.ZB, oneof: "message" },
    { no: 5, name: "order_detail", kind: "message", T: portfolio_pb/* Order */.KM, oneof: "message" },
    { no: 6, name: "order_list", kind: "message", T: WebsocketResponse_OrderList, oneof: "message" },
    { no: 7, name: "portfolio_detail_day_trade", kind: "message", T: portfolio_pb/* PortfolioDetail */.$2, oneof: "message" },
  ],
);

/**
 * Action provides various action can applied to websocket message
 *
 * @generated from enum securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action
 */
const WebsocketResponse_Action = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action",
  [
    {no: 0, name: "ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_UPSERT", localName: "UPSERT"},
    {no: 2, name: "ACTION_DELETE", localName: "DELETE"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList
 */
const WebsocketResponse_OrderList = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList",
  () => [
    { no: 1, name: "orders", kind: "message", T: portfolio_pb/* Order */.KM, repeated: true },
  ],
  {localName: "WebsocketResponse_OrderList"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/websocket_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/websocket.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck






/**
 * WebsocketRequest handles request for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest
 */
const WebsocketRequest = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest",
  () => [
    { no: 1, name: "requests", kind: "message", T: WebsocketRequest_Request, repeated: true },
  ],
);

/**
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest.Request
 */
const WebsocketRequest_Request = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "command", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Command), oneof: "action" },
    { no: 3, name: "subscribe", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
    { no: 4, name: "unsubscribe", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
  ],
  {localName: "WebsocketRequest_Request"},
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Command
 */
const WebsocketRequest_Request_Command = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Command",
  [
    {no: 0, name: "COMMAND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMAND_PING", localName: "PING"},
    {no: 2, name: "COMMAND_AUTH", localName: "AUTH"},
  ],
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel
 */
const WebsocketRequest_Request_Channel = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel",
  [
    {no: 0, name: "CHANNEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CHANNEL_SECURITIES_LIVE_PORTO", localName: "SECURITIES_LIVE_PORTO"},
  ],
);

/**
 * WebsocketResponse handles response for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketResponse
 */
const websocket_pb_WebsocketResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "ping", kind: "message", T: PingResponse, oneof: "response" },
    { no: 3, name: "auth", kind: "message", T: AuthResponse, oneof: "response" },
    { no: 4, name: "securities", kind: "message", T: WebsocketResponse, oneof: "response" },
  ],
);



/***/ }),

/***/ 80139:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BJ": function() { return /* binding */ ActionTarget; },
  "KM": function() { return /* binding */ Order; },
  "y$": function() { return /* binding */ Order_GTC_GTCStatus; },
  "$2": function() { return /* binding */ PortfolioDetail; },
  "ZB": function() { return /* binding */ PortfolioList; },
  "XJ": function() { return /* binding */ PortfolioSummary; },
  "MF": function() { return /* binding */ Side; },
  "HG": function() { return /* binding */ SmartOrderLabelType; }
});

// UNUSED EXPORTS: BracketOrderChild, BracketOrderChild_Action, BracketOrderChild_GTC, BracketOrderChild_GTC_GTCStatus, BracketOrderChild_PriceChild, BracketOrderChild_ProfitLoss, Company, ExerciseData, ExerciseData_Date, Haircut, LeverageType, OrderBookSide, OrderDetail, OrderDetail_Action, OrderDetail_Amount, OrderDetail_Amount_Fee, OrderDetail_Amount_Fee_Matched, OrderDetail_DayTrade, OrderDetail_DayTradeForceSell, OrderDetail_GTC, OrderDetail_GTC_GTCStatus, OrderDetail_Price, OrderDetail_Price_Average, OrderDetail_Qty, OrderDetail_SmartOrder, OrderDetail_SmartOrder_ConfigPriceType, OrderDetail_SmartOrder_TrailingStop, OrderDetail_SmartOrder_VolumeTriggerOrder, OrderDetail_Time, OrderDetail_TimeUTC, OrderType, Order_Action, Order_Amount, Order_Amount_Fee, Order_Amount_Fee_Matched, Order_DayTrade, Order_DayTradeForceSell, Order_GTC, Order_Price, Order_Price_Average, Order_Qty, Order_SmartOrder, Order_SmartOrder_TrailingStop, Order_Time, Order_TimeUTC, PlatformOrderType, PortfolioAsset, PortfolioAsset_Unrealised, PortfolioDetail_Bond, PortfolioDetail_Bond_Coupon, PortfolioFlags, PortfolioItem, PortfolioList_SmartOrderInfo, PortfolioPrice, PortfolioPrice_Average, PortfolioQty, PortfolioQty_Qty, PortfolioSummary_Amount, PortfolioSummary_Debt, PortfolioSummary_ProfitLoss, PortfolioSummary_Trading, SecuritiesKind

// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/proto3.js + 19 modules
var esm_proto3 = __webpack_require__(7722);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/google/protobuf/timestamp_pb.js
var timestamp_pb = __webpack_require__(27251);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/smart_order/trailing_stop/order/entity/v1/price_algorithm_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/smart_order/trailing_stop/order/entity/v1/price_algorithm.proto (package securities.trm.core.smart_order.trailing_stop.order.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from enum securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithmType
 */
const PriceAlgorithmType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithmType",
  [
    {no: 0, name: "PRICE_ALGORITHM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PRICE_ALGORITHM_TYPE_TRAILING_STOP_PERCENTAGE", localName: "TRAILING_STOP_PERCENTAGE"},
  ],
);

/**
 * @generated from message securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithm
 */
const PriceAlgorithm = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithm",
  () => [
    { no: 1, name: "type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PriceAlgorithmType) },
    { no: 2, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/google/type/money_pb.js
// Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.3.0 with parameter "target=js+dts"
// @generated from file google/type/money.proto (package google.type, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * Represents an amount of money with its currency type.
 *
 * @generated from message google.type.Money
 */
const Money = esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "google.type.Money",
  () => [
    { no: 1, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "units", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "nanos", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/google/type/date_pb.js
// Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.3.0 with parameter "target=js+dts"
// @generated from file google/type/date.proto (package google.type, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * Represents a whole or partial calendar date, such as a birthday. The time of
 * day and time zone are either specified elsewhere or are insignificant. The
 * date is relative to the Gregorian Calendar. This can represent one of the
 * following:
 *
 * * A full date, with non-zero year, month, and day values
 * * A month and day value, with a zero year, such as an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, such as a credit card expiration
 * date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
 * `google.protobuf.Timestamp`.
 *
 * @generated from message google.type.Date
 */
const date_pb_Date = esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "google.type.Date",
  () => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "day", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/entity/v2/portfolio_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/entity/v2/portfolio.proto (package securities.trm.core.portfolio.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck






/**
 * Side defines sides for an order
 *
 * @generated from enum securities.trm.core.portfolio.entity.v2.Side
 */
const Side = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Side",
  [
    {no: 0, name: "SIDE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIDE_BUY", localName: "BUY"},
    {no: 2, name: "SIDE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.PlatformOrderType
 */
const PlatformOrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.PlatformOrderType",
  [
    {no: 0, name: "PLATFORM_ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLATFORM_ORDER_TYPE_LIMIT_DAY", localName: "LIMIT_DAY"},
    {no: 2, name: "PLATFORM_ORDER_TYPE_MARKET_FAK", localName: "MARKET_FAK"},
    {no: 3, name: "PLATFORM_ORDER_TYPE_FAST_ORDER", localName: "FAST_ORDER"},
  ],
);

/**
 * this number same like AutoOrderLabel
 *
 * @generated from enum securities.trm.core.portfolio.entity.v2.SmartOrderLabelType
 */
const SmartOrderLabelType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.SmartOrderLabelType",
  [
    {no: 0, name: "SMART_ORDER_LABEL_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SMART_ORDER_LABEL_TYPE_AUTO_BUY", localName: "AUTO_BUY"},
    {no: 2, name: "SMART_ORDER_LABEL_TYPE_STOP_LOSS", localName: "STOP_LOSS"},
    {no: 3, name: "SMART_ORDER_LABEL_TYPE_TAKE_PROFIT", localName: "TAKE_PROFIT"},
    {no: 5, name: "SMART_ORDER_LABEL_TYPE_TRAILING_STOP", localName: "TRAILING_STOP"},
    {no: 6, name: "SMART_ORDER_LABEL_TYPE_LIMIT_IF_TOUCHED", localName: "LIMIT_IF_TOUCHED"},
    {no: 7, name: "SMART_ORDER_LABEL_TYPE_BRACKET_ORDER", localName: "BRACKET_ORDER"},
    {no: 8, name: "SMART_ORDER_LABEL_TYPE_VOLUME_TRIGGER_ORDER", localName: "VOLUME_TRIGGER_ORDER"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.ActionTarget
 */
const ActionTarget = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.ActionTarget",
  [
    {no: 0, name: "ACTION_TARGET_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_TARGET_REGULAR", localName: "REGULAR"},
    {no: 2, name: "ACTION_TARGET_DAY_TRADE", localName: "DAY_TRADE"},
    {no: 3, name: "ACTION_TARGET_LEGACY_SMARTORDER", localName: "LEGACY_SMARTORDER"},
    {no: 4, name: "ACTION_TARGET_TRAILING_STOP", localName: "TRAILING_STOP"},
    {no: 5, name: "ACTION_TARGET_STOP_ORDER", localName: "STOP_ORDER"},
    {no: 6, name: "ACTION_TARGET_BRACKET_ORDER", localName: "BRACKET_ORDER"},
    {no: 7, name: "ACTION_TARGET_VOLUME_TRIGGER_ORDER", localName: "VOLUME_TRIGGER_ORDER"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderType
 */
const OrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_LIMIT", localName: "LIMIT"},
    {no: 2, name: "ORDER_TYPE_MARKET", localName: "MARKET"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.LeverageType
 */
const LeverageType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.LeverageType",
  [
    {no: 0, name: "LEVERAGE_TYPE_TRADING_UNSPECIFIED", localName: "TRADING_UNSPECIFIED"},
    {no: 1, name: "LEVERAGE_TYPE_TRADING_BALANCE", localName: "TRADING_BALANCE"},
    {no: 2, name: "LEVERAGE_TYPE_TRADING_LIMIT", localName: "TRADING_LIMIT"},
    {no: 3, name: "LEVERAGE_TYPE_BASIC_LIMIT", localName: "BASIC_LIMIT"},
    {no: 4, name: "LEVERAGE_TYPE_TEMP_LIMIT", localName: "TEMP_LIMIT"},
    {no: 5, name: "LEVERAGE_TYPE_DAY_TRADE", localName: "DAY_TRADE"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.SecuritiesKind
 */
const SecuritiesKind = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.SecuritiesKind",
  [
    {no: 0, name: "SECURITIES_KIND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SECURITIES_KIND_STOCK", localName: "STOCK"},
    {no: 2, name: "SECURITIES_KIND_BOND", localName: "BOND"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderBookSide
 */
const OrderBookSide = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderBookSide",
  [
    {no: 0, name: "ORDER_BOOK_SIDE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_BOOK_SIDE_BID", localName: "BID"},
    {no: 2, name: "ORDER_BOOK_SIDE_ASK", localName: "ASK"},
  ],
);

/**
 * PortfolioListSummary contains summary of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary
 */
const PortfolioSummary = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary",
  () => [
    { no: 1, name: "trading", kind: "message", T: PortfolioSummary_Trading },
    { no: 2, name: "amount", kind: "message", T: PortfolioSummary_Amount },
    { no: 3, name: "profit_loss", kind: "message", T: PortfolioSummary_ProfitLoss },
    { no: 4, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "equity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "debt", kind: "message", T: PortfolioSummary_Debt },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading
 */
const PortfolioSummary_Trading = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading",
  () => [
    { no: 1, name: "balance", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Trading"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount
 */
const PortfolioSummary_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "allocated", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "credit_limit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss
 */
const PortfolioSummary_ProfitLoss = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss",
  () => [
    { no: 1, name: "net", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "unrealised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "realised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_ProfitLoss"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt
 */
const PortfolioSummary_Debt = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt",
  () => [
    { no: 1, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Debt"},
);

/**
 * PortfolioPrice contains price information in portfolio for one symbol
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice
 */
const PortfolioPrice = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice",
  () => [
    { no: 1, name: "latest", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: PortfolioPrice_Average },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average
 */
const PortfolioPrice_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioPrice_Average"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty
 */
const PortfolioQty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty",
  () => [
    { no: 1, name: "stock_on_hand", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "available", kind: "message", T: PortfolioQty_Qty },
    { no: 3, name: "balance", kind: "message", T: PortfolioQty_Qty },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty
 */
const PortfolioQty_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty",
  () => [
    { no: 1, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "share", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioQty_Qty"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset
 */
const PortfolioAsset = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset",
  () => [
    { no: 1, name: "unrealised", kind: "message", T: PortfolioAsset_Unrealised },
    { no: 2, name: "amount_invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised
 */
const PortfolioAsset_Unrealised = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised",
  () => [
    { no: 1, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "profit_loss", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioAsset_Unrealised"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioFlags
 */
const PortfolioFlags = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioFlags",
  () => [
    { no: 1, name: "allow_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "have_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "can_buy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "can_sell", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Order defines information on a single order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order
 */
const Order = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: Order_Time },
    { no: 8, name: "qty", kind: "message", T: Order_Qty },
    { no: 9, name: "price", kind: "message", T: Order_Price },
    { no: 10, name: "amount", kind: "message", T: Order_Amount },
    { no: 11, name: "action", kind: "message", T: Order_Action },
    { no: 12, name: "smart_order", kind: "message", T: Order_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: Order_GTC },
    { no: 14, name: "day_trade", kind: "message", T: Order_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "securities_kind", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SecuritiesKind) },
    { no: 18, name: "platform_order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PlatformOrderType) },
    { no: 19, name: "time_utc", kind: "message", T: Order_TimeUTC },
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell
 */
const Order_DayTradeForceSell = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount
 */
const Order_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: Order_Amount_Fee },
  ],
  {localName: "Order_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee
 */
const Order_Amount_Fee = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: Order_Amount_Fee_Matched },
  ],
  {localName: "Order_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched
 */
const Order_Amount_Fee_Matched = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price
 */
const Order_Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: Order_Price_Average },
  ],
  {localName: "Order_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price.Average
 */
const Order_Price_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Time
 */
const Order_Time = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Time",
  () => [
    { no: 1, name: "order", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "open", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "match", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "Order_Time"},
);

/**
 * TimeUTC contains time-related information for order in UTC timezone
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.TimeUTC
 */
const Order_TimeUTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.TimeUTC",
  () => [
    { no: 1, name: "order", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "open", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "match", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 4, name: "gtc_expired", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "Order_TimeUTC"},
);

/**
 * Action defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Action
 */
const Order_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "amend_target", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ActionTarget) },
    { no: 4, name: "cancel_target", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ActionTarget) },
  ],
  {localName: "Order_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder
 */
const Order_SmartOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "trailing_stop", kind: "message", T: Order_SmartOrder_TrailingStop },
    { no: 6, name: "bracket_order_children", kind: "message", T: BracketOrderChild, repeated: true },
    { no: 7, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderType) },
  ],
  {localName: "Order_SmartOrder"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder.TrailingStop
 */
const Order_SmartOrder_TrailingStop = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder.TrailingStop",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "price_algorithm", kind: "message", T: PriceAlgorithm },
    { no: 3, name: "stop_price", kind: "message", T: Money },
  ],
  {localName: "Order_SmartOrder_TrailingStop"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.GTC
 */
const Order_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Order_GTC_GTCStatus) },
  ],
  {localName: "Order_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus
 */
const Order_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Qty
 */
const Order_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.DayTrade
 */
const Order_DayTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Order_DayTradeForceSell) },
  ],
  {localName: "Order_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail
 */
const OrderDetail = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: OrderDetail_Time },
    { no: 8, name: "qty", kind: "message", T: OrderDetail_Qty },
    { no: 9, name: "price", kind: "message", T: OrderDetail_Price },
    { no: 10, name: "amount", kind: "message", T: OrderDetail_Amount },
    { no: 11, name: "action", kind: "message", T: OrderDetail_Action },
    { no: 12, name: "smart_order", kind: "message", T: OrderDetail_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: OrderDetail_GTC },
    { no: 14, name: "day_trade", kind: "message", T: OrderDetail_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: proto3.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "platform_order_type", kind: "enum", T: proto3.getEnumType(PlatformOrderType) },
    { no: 18, name: "time_utc", kind: "message", T: OrderDetail_TimeUTC },
  ],
)));

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell
 */
const OrderDetail_DayTradeForceSell = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount
 */
const OrderDetail_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: OrderDetail_Amount_Fee },
  ],
  {localName: "OrderDetail_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee
 */
const OrderDetail_Amount_Fee = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: OrderDetail_Amount_Fee_Matched },
  ],
  {localName: "OrderDetail_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched
 */
const OrderDetail_Amount_Fee_Matched = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price
 */
const OrderDetail_Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: OrderDetail_Price_Average },
  ],
  {localName: "OrderDetail_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average
 */
const OrderDetail_Price_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "portfolio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Time
 */
const OrderDetail_Time = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Time",
  () => [
    { no: 1, name: "ordered_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "opened_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "matched_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "OrderDetail_Time"},
);

/**
 * TimeUTC contains time-related information for order in UTC timezone
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.TimeUTC
 */
const OrderDetail_TimeUTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.TimeUTC",
  () => [
    { no: 1, name: "ordered_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "opened_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "matched_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 4, name: "gtc_expired_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "OrderDetail_TimeUTC"},
);

/**
 * Action defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Action
 */
const OrderDetail_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "amend_target", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ActionTarget) },
    { no: 4, name: "cancel_target", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ActionTarget) },
  ],
  {localName: "OrderDetail_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder
 */
const OrderDetail_SmartOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_SmartOrder_ConfigPriceType) },
    { no: 5, name: "trailing_stop", kind: "message", T: OrderDetail_SmartOrder_TrailingStop },
    { no: 6, name: "bracket_order_children", kind: "message", T: BracketOrderChild, repeated: true },
    { no: 7, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderType) },
    { no: 10, name: "volume_trigger_order", kind: "message", T: OrderDetail_SmartOrder_VolumeTriggerOrder },
  ],
  {localName: "OrderDetail_SmartOrder"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType
 */
const OrderDetail_SmartOrder_ConfigPriceType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType",
  [
    {no: 0, name: "CONFIG_PRICE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONFIG_PRICE_TYPE_ABOVE", localName: "ABOVE"},
    {no: 2, name: "CONFIG_PRICE_TYPE_BELOW", localName: "BELOW"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.TrailingStop
 */
const OrderDetail_SmartOrder_TrailingStop = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.TrailingStop",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "price_algorithm", kind: "message", T: PriceAlgorithm },
    { no: 3, name: "stop_price", kind: "message", T: Money },
  ],
  {localName: "OrderDetail_SmartOrder_TrailingStop"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.VolumeTriggerOrder
 */
const OrderDetail_SmartOrder_VolumeTriggerOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.VolumeTriggerOrder",
  () => [
    { no: 1, name: "trigger_volume", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "evaluation_price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "evaluation_order_book_side", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderBookSide) },
  ],
  {localName: "OrderDetail_SmartOrder_VolumeTriggerOrder"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.GTC
 */
const OrderDetail_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_GTC_GTCStatus) },
  ],
  {localName: "OrderDetail_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus
 */
const OrderDetail_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Qty
 */
const OrderDetail_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade
 */
const OrderDetail_DayTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_DayTradeForceSell) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "OrderDetail_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild
 */
const BracketOrderChild = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "side", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Side) },
    { no: 4, name: "price", kind: "message", T: BracketOrderChild_PriceChild },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "gtc", kind: "message", T: BracketOrderChild_GTC },
    { no: 7, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "label", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SmartOrderLabelType) },
    { no: 10, name: "profit_loss", kind: "message", T: BracketOrderChild_ProfitLoss },
    { no: 11, name: "action", kind: "message", T: BracketOrderChild_Action },
    { no: 12, name: "lot_ordered", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "amount_ordered", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "amount_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "platform_order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PlatformOrderType) },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild.PriceChild
 */
const BracketOrderChild_PriceChild = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.PriceChild",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "price_difference_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "trigger", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "BracketOrderChild_PriceChild"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild.GTC
 */
const BracketOrderChild_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(BracketOrderChild_GTC_GTCStatus) },
  ],
  {localName: "BracketOrderChild_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.BracketOrderChild.GTC.GTCStatus
 */
const BracketOrderChild_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild.ProfitLoss
 */
const BracketOrderChild_ProfitLoss = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.ProfitLoss",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "BracketOrderChild_ProfitLoss"},
);

/**
 * Action defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.BracketOrderChild.Action
 */
const BracketOrderChild_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.BracketOrderChild.Action",
  () => [
    { no: 1, name: "amend_target", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ActionTarget) },
    { no: 2, name: "cancel_target", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(ActionTarget) },
  ],
  {localName: "BracketOrderChild_Action"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Company
 */
const Company = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Company",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData
 */
const ExerciseData = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "date", kind: "message", T: ExerciseData_Date },
    { no: 9, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData.Date
 */
const ExerciseData_Date = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData.Date",
  () => [
    { no: 1, name: "listing", kind: "message", T: date_pb_Date },
    { no: 2, name: "expired", kind: "message", T: date_pb_Date },
    { no: 3, name: "mature", kind: "message", T: date_pb_Date },
    { no: 4, name: "start", kind: "message", T: date_pb_Date },
    { no: 5, name: "end", kind: "message", T: date_pb_Date },
  ],
  {localName: "ExerciseData_Date"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Haircut
 */
const Haircut = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Haircut",
  () => [
    { no: 1, name: "trading_limit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "margin_trading", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioItem
 */
const PortfolioItem = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioItem",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "haircut", kind: "message", T: Haircut },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail
 */
const PortfolioDetail = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "bond", kind: "message", T: PortfolioDetail_Bond },
    { no: 9, name: "can_create_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond
 */
const PortfolioDetail_Bond = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond",
  () => [
    { no: 1, name: "coupon", kind: "message", T: PortfolioDetail_Bond_Coupon },
    { no: 2, name: "maturity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon
 */
const PortfolioDetail_Bond_Coupon = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon",
  () => [
    { no: 1, name: "year_rate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "distribution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond_Coupon"},
);

/**
 * PortfolioList defines data on response PortfolioListResponse
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList
 */
const PortfolioList = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList",
  () => [
    { no: 1, name: "smart_order_info", kind: "message", T: PortfolioList_SmartOrderInfo },
    { no: 2, name: "summary", kind: "message", T: PortfolioSummary },
    { no: 3, name: "results", kind: "message", T: PortfolioItem, repeated: true },
    { no: 4, name: "day_trade", kind: "message", T: PortfolioItem, repeated: true },
  ],
);

/**
 * PortfolioListInfo contains info of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo
 */
const PortfolioList_SmartOrderInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo",
  () => [
    { no: 1, name: "can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "day_trade_can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "PortfolioList_SmartOrderInfo"},
);



/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

}]);